import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.CHANGE_PASSWORD_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.CHANGE_PASSWORD_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_ACCOUNT_CHANGE_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
